import { render, staticRenderFns } from "./SimilarListingsStockToggle.vue?vue&type=template&id=12cfbb84&"
import script from "./SimilarListingsStockToggle.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsStockToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports